var r,t;!function(r){r.QA="qa",r.STAGING="stage",r.PRODUCTION="prod"}(r||(r={})),function(r){r.Light="light",r.Grey="grey",r.Dark="dark"}(t||(t={}));export{r as Environment,t as Theme};
//# sourceMappingURL=index.esm.js.map
